import { toast } from "sonner";

let loading = null;
const loadScript = () => {
  if (window.Razorpay) return Promise.resolve(true);
  if (!loading) {
    loading = new Promise((resolve) => {
      const s = document.createElement("script");
      s.src = "https://checkout.razorpay.com/v1/checkout.js";
      s.onload = () => resolve(true);
      s.onerror = () => { loading = null; resolve(false); };
      document.body.appendChild(s);
    });
  }
  return loading;
};

export async function openRazorpay(rzp, { onSuccess, onDismiss }) {
  const ok = await loadScript();
  if (!ok) { toast.error("Couldn't load Razorpay. Check your connection and try again."); onDismiss?.(); return; }
  const instance = new window.Razorpay({
    key: rzp.key_id,
    amount: rzp.amount,
    currency: rzp.currency,
    order_id: rzp.order_id,
    name: rzp.name,
    description: rzp.description,
    prefill: rzp.prefill,
    notes: { app: "cpd" },
    theme: { color: "#3B5BDB" },
    retry: { enabled: true, max_count: 3 },
    handler: (res) => onSuccess(res),
    modal: { ondismiss: () => onDismiss?.(), confirm_close: true },
  });
  instance.on("payment.failed", (res) => toast.error(res?.error?.description || "Payment failed. Please try again."));
  instance.open();
}
